module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("thank_you").tTitle()))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t("your_deposit_successful")))]), _vm._v(" "), _c('hr')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d1372cd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/finance/deposit-return/Success.vue
// module id = 754
// module chunks = 0